//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
	async fetch() {
		await Promise.all([ 
			this.$store.dispatch('subscriptionsStore/getSubscriptions', this.queries.subscriptions),
			this.$store.dispatch('subscriptionsStore/getCreditbundles', this.queries.creditbundles)
			])
	},
	components: {
		payPerMinute: () => import('~/components/payment/ppm.vue'),
		payPerMobile: () => import('~/components/payment/mobile_pincode.vue'),
		bancontact: () => import('@/assets/svg/bancontact.svg'),
	},
	computed: {
		...mapState({
			ppmStatus: ({ ppmStore: {ppmStatus} }) => ppmStatus,
			status: ({ paywallStore: {status} }) => status,
			queries: ({ subscriptionsStore: {queries} }) => queries,
			subscriptions: ({ subscriptionsStore: {subscriptions} }) => subscriptions,
			subscription: ({ subscriptionsStore: {subscription} }) => subscription,
			subscription_detail: ({ subscriptionsStore: {subscription_detail} }) => subscription_detail,
			creditbundles: ({ subscriptionsStore: {creditbundles} }) => creditbundles,
			creditbundle: ({ subscriptionsStore: {creditbundle} }) => creditbundle,
			product_to_pay: ({ subscriptionsStore: {product_to_pay} }) => product_to_pay,
			coupon: ({ subscriptionsStore: {coupon} }) => coupon,
			resource: ({ resourcesStore: {video} }) => video,
			episode: ({ resourcesStore: {episode} }) => episode,
		}),
	},
	watch: {
		'status.step': function(newVal, oldVal) {
			if(newVal === 3) {
				document.body.classList.add('scroll-off');
			} else {
				document.body.classList.remove('scroll-off');
			}
		},
		'coupon.active': function(newVal, oldVal) {
			this.$forceUpdate();
		},
		'coupon': function(newVal, oldVal) {
			this.$forceUpdate();
		},
		'subscriptions': function(newVal, oldVal) {
			// This sets the most attractive subscription active
			if (this.subscriptions && this.subscriptions.data && this.subscriptions.data.length) {
				 // Find the subscription detail with the slug "unlimited-abonnement"
				const detail = this.subscriptions.data[0].details.data.find(
					(item) => item.slug === "unlimited-abonnement"
					);
				// Check if the detail was found, then set it as active					
				if (detail) {
					this.$store.commit('subscriptionsStore/setSubscription', this.subscriptions.data[0]);
					this.$store.commit('subscriptionsStore/setSubscriptionDetail', detail);
				}
			}
		},

		'subscription': function(newVal, oldVal) {
			console.log(newVal);
			if (newVal.name === 'subscription') {
				this.dataSet = newVal.details.data;
				const detail = this.dataSet.find(
					(item) => item.slug === "unlimited-abonnement"
					);
				this.$store.commit('subscriptionsStore/setProductToPay', detail);
			} else {
				this.dataSet = this.creditbundles.data;
				if (this.creditbundles.data.length) {
					this.$store.commit('subscriptionsStore/setProductToPay', this.creditbundles.data[1]);
				}
			}
		}
	},
	data() {
		return {
			dataSet: null,
			coupontext: '',
			showExtraDetails: false
		}
	},
	mounted: function() {
	},
	methods: {

	}
}	
